import React, { useState } from 'react';

const PortfolioSection = () => {
  const [activeCategory, setActiveCategory] = useState('all');

  const categories = [
    { id: 'all', label: '전체' },
    { id: 'system', label: '업무 시스템' },
    { id: 'service', label: '서비스 개발' },
  ];

  const projects = [
    {
      id: 'moaman',
      category: 'system',
      title: '병원 CRM+EMR 통합 시스템',
      client: '탈모전문병원',
      type: '업무 시스템 구축',
      description: '마케팅 CRM과 전자의무기록(EMR)을 단일 플랫폼으로 통합하여 병원 운영 전반을 디지털화',
      features: [
        '멀티채널 신청자 통합 관리',
        '환자 전환 퍼널 분석 및 마케팅 ROI 대시보드',
        'EMR 연동: 환자 정보, 진료 기록, 전자동의서',
        'AES-256 암호화 (개인정보보호법 준수)',
      ],
      techStack: ['React', 'Node.js', 'Express', 'MySQL', 'AWS EC2'],
      impact: '일 평균 50건+ 상담 처리 · 상담사 업무 효율 40% 개선',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
        </svg>
      ),
    },
    {
      id: 'mattandmel',
      category: 'service',
      title: 'Matt & Mel 쇼핑몰 리뉴얼',
      client: '라이프스타일 브랜드',
      type: '웹사이트 리뉴얼',
      description: '브랜드 아이덴티티를 극대화한 인터랙티브 쇼핑몰 메인 페이지 리뉴얼',
      features: [
        'Scroll-triggered 텍스트 애니메이션 시스템',
        '브랜드 일러스트 기반 비주얼 모티프',
        'Drag Carousel, 반응형 레이아웃',
        'Cafe24 플랫폼 최적화',
      ],
      techStack: ['HTML5', 'CSS3', 'JavaScript', 'Cafe24'],
      impact: '페이지 체류 시간 2배 증가 · 브랜드 감성을 살린 몰입형 UX 구현',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />
        </svg>
      ),
    },
    {
      id: 'fotp',
      category: 'service',
      title: 'FOTP 기업 웹사이트',
      client: '브랜드 컨설팅 에이전시',
      type: '기업 웹사이트 구축',
      description: '브랜드 디렉션 & 비즈니스 아키텍처 전문 에이전시의 기업 웹사이트 구축',
      features: [
        'Marquee Text Animation 배경 시스템',
        'Dark Theme 기반 미니멀 디자인',
        'Typography 중심 레이아웃',
        '브랜드 철학의 시각적 표현',
      ],
      techStack: ['HTML5', 'CSS3', 'JavaScript'],
      impact: '브랜드 철학을 효과적으로 전달하는 랜딩 페이지 완성',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9" />
        </svg>
      ),
    },
    {
      id: 'stau',
      category: 'service',
      title: 'STAU T2E 게임',
      client: 'Web3 스타트업',
      type: '텔레그램 미니앱 개발',
      description: 'Telegram 생태계 기반 Tap-to-Earn 게임 · Polygon 블록체인 토큰 연동',
      features: [
        'Telegram Mini App 네이티브 최적화',
        '게임 로직/토큰 구조 분리 설계',
        'Firebase + Bot 기반 운영 자동화',
        '다국어 지원 (EN/KR)',
      ],
      techStack: ['JavaScript', 'Firebase', 'Node.js', 'Polygon', 'Telegram API'],
      impact: '글로벌 5,000+ 유저 확보 · 무인 운영 체계 구축',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      ),
    },
  ];

  const filteredProjects = activeCategory === 'all'
    ? projects
    : projects.filter(p => p.category === activeCategory);

  return (
    <section id="portfolio" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <span className="inline-block px-3 py-1 bg-primary/10 text-primary rounded-full text-sm font-medium mb-4">
            포트폴리오
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-dark mb-4">
            실제 <span className="text-primary">운영 중인</span> 프로젝트
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            GenAI Dev는 "만드는 것"에서 끝나지 않고, "돌아가게 만드는 것"까지 책임집니다.
            기획부터 개발, 배포, 운영까지 서비스가 실제로 성과를 내는 순간까지 함께합니다.
          </p>
        </div>

        {/* 카테고리 필터 */}
        <div className="flex flex-wrap justify-center mb-10 gap-2">
          {categories.map((cat) => (
            <button
              key={cat.id}
              className={`px-5 py-2 rounded-full text-sm font-medium transition-colors ${
                activeCategory === cat.id
                  ? 'bg-primary text-white'
                  : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
              }`}
              onClick={() => setActiveCategory(cat.id)}
            >
              {cat.label}
            </button>
          ))}
        </div>

        {/* 프로젝트 그리드 */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {filteredProjects.map((project) => (
            <div
              key={project.id}
              className="bg-light rounded-xl shadow-md hover:shadow-lg transition-all duration-300 overflow-hidden group"
            >
              {/* 프로젝트 헤더 */}
              <div className="bg-gradient-to-r from-primary/10 to-primary/5 p-6">
                <div className="flex items-start justify-between mb-4">
                  <div className="w-12 h-12 bg-primary/20 rounded-lg flex items-center justify-center text-primary">
                    {project.icon}
                  </div>
                  <span className="text-xs font-medium text-primary bg-white px-2 py-1 rounded">
                    {project.type}
                  </span>
                </div>
                <h3 className="text-xl font-bold text-dark mb-1">{project.title}</h3>
                <p className="text-sm text-gray-500">{project.client}</p>
              </div>

              {/* 프로젝트 본문 */}
              <div className="p-6">
                <p className="text-gray-600 text-sm mb-4">{project.description}</p>

                {/* 주요 기능 */}
                <div className="mb-4">
                  <h4 className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-2">주요 기능</h4>
                  <ul className="space-y-1">
                    {project.features.slice(0, 3).map((feature, idx) => (
                      <li key={idx} className="flex items-start text-sm text-gray-600">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-primary mr-2 flex-shrink-0 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                        </svg>
                        {feature}
                      </li>
                    ))}
                  </ul>
                </div>

                {/* 기술 스택 */}
                <div className="mb-4">
                  <h4 className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-2">기술 스택</h4>
                  <div className="flex flex-wrap gap-1">
                    {project.techStack.map((tech, idx) => (
                      <span key={idx} className="text-xs bg-gray-200 text-gray-600 px-2 py-1 rounded">
                        {tech}
                      </span>
                    ))}
                  </div>
                </div>

                {/* 성과 */}
                <div className="pt-4 border-t border-gray-200">
                  <div className="flex items-start">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-primary mr-2 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
                    </svg>
                    <p className="text-sm text-gray-700 font-medium">{project.impact}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="mt-16 text-center">
          <div className="bg-gradient-to-r from-primary/5 to-primary/10 rounded-2xl p-8 md:p-12">
            <h3 className="text-2xl font-bold text-dark mb-4">
              프로젝트를 함께 만들어갈 준비가 되셨나요?
            </h3>
            <p className="text-gray-600 mb-6 max-w-xl mx-auto">
              업무 시스템 구축, 웹/앱 서비스 개발, AI 자동화까지
              비즈니스 목표에 맞춘 최적의 솔루션을 제안해 드립니다.
            </p>
            <a
              href="#contact"
              className="inline-block bg-primary text-white px-8 py-3 rounded-md font-medium hover:bg-primary/90 transition-colors"
            >
              프로젝트 문의하기
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PortfolioSection;
